// BRN-2118 (AC1, AC7) — per-env derivation of BRAIN's IAM base URL from BRAIN's OWN public hostname.
// The sibling of deriveAgentsEmbedUrl (agents-embed-origin.ts) with the product label swapped
// brain -> iam. Replaces environment.prod.ts's previous `host.includes('qa')` qa/prod binary — a
// looser substring test a hostname like `qa-evil.example.com` would also satisfy — with the SAME
// STRUCTURAL label transform, so qa, prod, AND any future commissioned/private-cloud environment
// resolve automatically, with no per-env branch and no hardcoded per-env origin.
//
// BRAIN is served per tenant at `<tenant>.<web-host-prefix>brain.<base-domain>` (qa:
// `<tenant>.qa.brain.gridwatchems.com`; prod apex: `<tenant>.brain.gridwatchems.com`) and its IAM
// surface at the sibling `<web-host-prefix>iam.<base-domain>`. So the origin is derived by dropping
// the single leading tenant label and swapping the product label `brain` -> `iam`:
//   santafenm.qa.brain.gridwatchems.com -> https://qa.iam.gridwatchems.com
//   santafenm.brain.gridwatchems.com    -> https://iam.gridwatchems.com
//   acme.dev.brain.example.internal     -> https://dev.iam.example.internal   (private cloud)
//
// ASSUMPTION (inherited UNCHANGED from deriveAgentsEmbedUrl — see its header + BRN-2118 report):
// BRAIN is always reached at `<tenant>.[<prefix>.]brain.<base-domain>` with EXACTLY ONE leading
// tenant label. This fix introduces NO new assumption beyond the one the sibling embed derivation
// already carries and flags for operator confirmation. If BRAIN can be reached tenant-LESS, the
// leading-label drop over-drops and the prefix must instead be injected from the registry
// web_host_prefix/base_domain as config, rather than derived from the host.

/** Pure, unit-testable: no `window` access, so the transform is provable in isolation. */
export function deriveBaseIamUrl(hostname: string): string {
  return 'https://' + hostname.replace(/^[^.]+\./, '').replace(/(^|\.)brain\./, '$1iam.');
}
